var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-dropdown',{attrs:{"icon-for-read-only-value":_vm.selectedLanguageFlag,"entries":_vm.languageList,"label":_vm.label,"required":_vm.required,"is-read-only":_vm.isReadOnly},on:{"select":_vm.onLanguageChange},model:{value:(_vm.localLanguage),callback:function ($$v) {_vm.localLanguage=$$v},expression:"localLanguage"}})
}
var staticRenderFns = []

export { render, staticRenderFns }